import NotFound from '@/pages/notFound/NotFound.page'
import TicketListServer from '@/pages/ticketListServer/TicketListServer.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { createAgentFeaturesByIdQuery } from '@/services/agent/agent.options'
import { useSuspenseQuery } from '@tanstack/react-query'
import TicketListClient from '@/pages/ticketListClient/TicketListClient.page'
import { createPermissionsQueryOptions } from '@/services/rolesPermissions/rolesPermission.options'
import { useAuth } from '@/lib/auth'
import { useMemo } from 'react'

export const Route = createFileRoute('/_auth/')({
  component: HomeLayout,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      drawer: search.drawer as 'create' | undefined,
    }
  },
  notFoundComponent: NotFound,
  loader: async ({ context }) => {
    const userQueryOptions = createPermissionsQueryOptions(context.auth.checkAuthStatus)
    const permissions = await context.queryClient.fetchQuery(userQueryOptions);
    const agentFeatureQueryOptions = createAgentFeaturesByIdQuery({ AgentId: permissions?.agentid });
    const agentFeatures = await context.queryClient.ensureQueryData(agentFeatureQueryOptions);

    return {
      permissions,
      agentFeatures
    }
  }
})

function HomeLayout() {
  const auth = useAuth();
  const permissions = useSuspenseQuery(createPermissionsQueryOptions(auth.checkAuthStatus))
  const agentFeaturesQuery = useSuspenseQuery(createAgentFeaturesByIdQuery({ AgentId: permissions.data?.agentid }))

  const serverSidePaging = useMemo(() =>
    agentFeaturesQuery.data?.Flags?.ServerSidePaging ?? false,
    [agentFeaturesQuery.data?.Flags?.ServerSidePaging]
  )

  return (
    <>
      {serverSidePaging ? <TicketListServer /> : <TicketListClient />}
      <Outlet />
    </>
  )
}
